import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold font-heading text-foreground-900 flex items-center gap-2">
          <i className="ri-article-line text-primary-500"></i>
          最新爆料
        </h2>
        <span className="text-xs text-foreground-500">共 {articles.length} 篇</span>
      </div>

      <div className="space-y-4">
        {latestArticles.map((article) => (
          <article key={article.id}>
            <Link
              to={`/article/${article.slug}`}
              className="flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 no-underline group"
            >
              <div className="relative w-full sm:w-44 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`黑料不打烊 ${article.category} ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      {article.category}
                    </span>
                    {article.trending && (
                      <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap flex items-center gap-1">
                        <i className="ri-fire-line text-[10px]"></i>
                        热门
                      </span>
                    )}
                  </div>
                  <h3 className="text-base font-semibold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-4 text-xs text-foreground-500 mt-3 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.views / 10000).toFixed(1)}万阅读
                  </span>
                </div>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
}